/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Files_On_ThreadInputs */

const es_tools_nexata_list_files_on_thread = /** @type {(inputs: Tools_Nexata_List_Files_On_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando archivos del hilo...`)
};

const en_tools_nexata_list_files_on_thread = /** @type {(inputs: Tools_Nexata_List_Files_On_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing thread files...`)
};

/**
* | output |
* | --- |
* | "Listing thread files..." |
*
* @param {Tools_Nexata_List_Files_On_ThreadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_files_on_thread = /** @type {((inputs?: Tools_Nexata_List_Files_On_ThreadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Files_On_ThreadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_files_on_thread(inputs)
	return en_tools_nexata_list_files_on_thread(inputs)
});
export { tools_nexata_list_files_on_thread as "tools.nexata.list_files_on_thread" }